export interface UzairueContact {
  id: string;
  fullName: string;
  title?: string;
  village: string;
  diasporaChapter: string;
  email: string;
  phone: string;
  whatsappEnabled: boolean;
  role: 'Royal Elder' | 'Diaspora Delegate' | 'Festival Coordinator' | 'Youth Leader' | 'General Diaspora Member';
  organization?: string;
  verified: boolean;
  notes?: string;
  createdAt: string;
}

export interface ChatMessage {
  id: string;
  channelId?: string; // e.g., 'general', 'planning', 'diaspora', 'cultural', 'sponsorship'
  recipientId?: string; // for DMs
  senderId: string;
  senderName: string;
  senderRole: string;
  senderVillage: string;
  content: string;
  attachedDocTitle?: string;
  attachedDocUrl?: string;
  timestamp: string;
}

export interface CollaborationTask {
  id: string;
  title: string;
  description: string;
  category: 'Logistics' | 'Cultural' | 'Fundraising' | 'Media & PR' | 'Protocol & Security';
  status: 'To Do' | 'In Progress' | 'Under Review' | 'Completed';
  priority: 'High' | 'Medium' | 'Low';
  assigneeName: string;
  assigneeVillage: string;
  dueDate: string;
  commentsCount: number;
}

export interface SystemBackupLog {
  id: string;
  timestamp: string;
  backupType: 'Automatic Periodic' | 'Manual User Triggered';
  contactsCount: number;
  messagesCount: number;
  tasksCount: number;
  fileSizeBytes: number;
  status: 'Success' | 'Failed';
  snapshotData?: string;
}

export const INITIAL_UZAIRUE_VILLAGES = [
  'Jattu-Uzairue',
  'Afashio-Uzairue',
  'Elele-Uzairue',
  'Ikabigbo-Uzairue',
  'Ayua-Uzairue',
  'Iyora-Uzairue',
  'Ugboa-Uzairue',
  'South Ibie-Uzairue',
  'Iyamho-Uzairue',
  'Ogbido-Uzairue',
  'Ayetoro-Uzairue',
  'Global Diaspora',
];

export const INITIAL_DIASPORA_CHAPTERS = [
  'Uzairue Local Govt / Edo State',
  'Abuja FCT Chapter',
  'Lagos & Western Nigeria Chapter',
  'United Kingdom & Ireland Chapter',
  'USA & Canada Diaspora Union',
  'European Union Chapter',
  'Asia-Pacific & Gulf Chapter',
];

export const INITIAL_CONTACTS: UzairueContact[] = [
  {
    id: 'cnt-1',
    fullName: 'High Chief Dr. Aliu Momoh',
    title: 'Daudu of Jattu',
    village: 'Jattu-Uzairue',
    diasporaChapter: 'Uzairue Local Govt / Edo State',
    email: 'aliu.momoh@uzairuekingom.org',
    phone: '+234 803 456 7890',
    whatsappEnabled: true,
    role: 'Royal Elder',
    organization: 'Uzairue Traditional Council',
    verified: true,
    notes: 'Chairman, Festival Central Steering Committee',
    createdAt: '2026-01-10T10:00:00Z',
  },
  {
    id: 'cnt-2',
    fullName: 'Engr. Fidelis Afegbua',
    title: 'President-General',
    village: 'Afashio-Uzairue',
    diasporaChapter: 'Abuja FCT Chapter',
    email: 'fidelis.afegbua@diaspora-uzairue.org',
    phone: '+234 802 334 5566',
    whatsappEnabled: true,
    role: 'Diaspora Delegate',
    organization: 'Uzairue World Development Association',
    verified: true,
    notes: 'Coordinating Abuja and Northern Delegates',
    createdAt: '2026-01-12T14:30:00Z',
  },
  {
    id: 'cnt-3',
    fullName: 'Bar. (Mrs.) Blessing Oshiomhole',
    title: 'Global Welfare Officer',
    village: 'Iyamho-Uzairue',
    diasporaChapter: 'United Kingdom & Ireland Chapter',
    email: 'blessing.o@uzairue-uk.org',
    phone: '+44 7700 900123',
    whatsappEnabled: true,
    role: 'Festival Coordinator',
    organization: 'Uzairue UK Diaspora Forum',
    verified: true,
    notes: 'In charge of UK & European Gala Dinner tickets',
    createdAt: '2026-01-15T09:15:00Z',
  },
  {
    id: 'cnt-4',
    fullName: 'Prince Usman Ikaro',
    title: 'Head of Cultural Troupes',
    village: 'Ikabigbo-Uzairue',
    diasporaChapter: 'Lagos & Western Nigeria Chapter',
    email: 'usman.ikaro@uzairueculture.org',
    phone: '+234 812 998 7766',
    whatsappEnabled: true,
    role: 'Festival Coordinator',
    organization: 'Uzairue Cultural Heritage Troupe',
    verified: true,
    notes: 'Overseeing traditional dances and masques',
    createdAt: '2026-01-20T11:45:00Z',
  },
  {
    id: 'cnt-5',
    fullName: 'Dr. Clementine Ayeni',
    title: 'North America Envoy',
    village: 'Ayua-Uzairue',
    diasporaChapter: 'USA & Canada Diaspora Union',
    email: 'ayeni.clement@uzairue-usa.org',
    phone: '+1 301 555 0192',
    whatsappEnabled: true,
    role: 'Diaspora Delegate',
    organization: 'Uzairue North America Association',
    verified: true,
    notes: 'Managing Diaspora Sponsorship & Endowment Fund',
    createdAt: '2026-02-01T16:20:00Z',
  },
  {
    id: 'cnt-6',
    fullName: 'Comrade Yakubu braimah',
    title: 'Youth President',
    village: 'Elele-Uzairue',
    diasporaChapter: 'Uzairue Local Govt / Edo State',
    email: 'yakubu.braimah@uzairueyouths.org',
    phone: '+234 703 112 3344',
    whatsappEnabled: true,
    role: 'Youth Leader',
    organization: 'Uzairue Youth Vanguard',
    verified: true,
    notes: 'Ground security and venue setup volunteers coordinator',
    createdAt: '2026-02-05T08:00:00Z',
  },
];

export const INITIAL_MESSAGES: ChatMessage[] = [
  {
    id: 'msg-1',
    channelId: 'general-announcements',
    senderId: 'cnt-1',
    senderName: 'High Chief Dr. Aliu Momoh',
    senderRole: 'Royal Elder',
    senderVillage: 'Jattu-Uzairue',
    content: 'Royal Proclamation: The 2026 ERUE Cultural Festival is officially scheduled for December 24–30, 2026 at the Ogieneni Palace Grounds! All committees are hereby inaugurated.',
    attachedDocTitle: 'Royal Festival Proclamation 2026',
    timestamp: '2026-08-10T10:00:00Z',
  },
  {
    id: 'msg-2',
    channelId: 'planning-committee',
    senderId: 'cnt-2',
    senderName: 'Engr. Fidelis Afegbua',
    senderRole: 'Diaspora Delegate',
    senderVillage: 'Afashio-Uzairue',
    content: 'Greetings Royal Elders and Delegates. The stage design blueprints and sound engineering contracts have been finalized. Please check the collaboration board for details.',
    timestamp: '2026-08-11T14:20:00Z',
  },
  {
    id: 'msg-3',
    channelId: 'diaspora-coordination',
    senderId: 'cnt-3',
    senderName: 'Bar. (Mrs.) Blessing Oshiomhole',
    senderRole: 'Festival Coordinator',
    senderVillage: 'Iyamho-Uzairue',
    content: 'UK, Europe and US flight charters are being organized. All diaspora sons and daughters are encouraged to register through the global contacts directory.',
    timestamp: '2026-08-12T09:30:00Z',
  },
];

export const INITIAL_TASKS: CollaborationTask[] = [
  {
    id: 'tsk-1',
    title: 'Ogieneni Palace Main Grandstand & VIP Canopy Erection',
    description: 'Procure and setup 5,000 capacity royal canopy, VIP leather seating, and elevated royal throne podium.',
    category: 'Logistics',
    status: 'In Progress',
    priority: 'High',
    assigneeName: 'Engr. Fidelis Afegbua',
    assigneeVillage: 'Afashio-Uzairue',
    dueDate: '2026-11-25',
    commentsCount: 8,
  },
  {
    id: 'tsk-2',
    title: '10 Sub-Clan Cultural Dance & Masque Rehearsals',
    description: 'Coordinate age-grade cultural dance troupes across Jattu, Afashio, Elele, Ikabigbo, Ayua, Iyora, Ugboa, South Ibie, Iyamho & Ogbido.',
    category: 'Cultural',
    status: 'In Progress',
    priority: 'High',
    assigneeName: 'Prince Usman Ikaro',
    assigneeVillage: 'Ikabigbo-Uzairue',
    dueDate: '2026-11-30',
    commentsCount: 14,
  },
  {
    id: 'tsk-3',
    title: 'Global Diaspora Charter Flight & Airport Shuttle Bus',
    description: 'Arrange dedicated shuttle buses from Benin Airport & Abuja to Uzairue for international guests.',
    category: 'Protocol & Security',
    status: 'To Do',
    priority: 'Medium',
    assigneeName: 'Bar. (Mrs.) Blessing Oshiomhole',
    assigneeVillage: 'Iyamho-Uzairue',
    dueDate: '2026-12-01',
    commentsCount: 3,
  },
  {
    id: 'tsk-4',
    title: 'Official Festival Souvenir Magazine & Commemorative Brochure',
    description: 'Print 10,000 copies of the royal festival program using the Uzairue Publishing Suite.',
    category: 'Media & PR',
    status: 'Completed',
    priority: 'High',
    assigneeName: 'Dr. Clementine Ayeni',
    assigneeVillage: 'Ayua-Uzairue',
    dueDate: '2026-10-15',
    commentsCount: 5,
  },
];

export const INITIAL_BACKUP_LOGS: SystemBackupLog[] = [
  {
    id: 'bkp-101',
    timestamp: '2026-08-12T20:00:00Z',
    backupType: 'Automatic Periodic',
    contactsCount: 6,
    messagesCount: 3,
    tasksCount: 4,
    fileSizeBytes: 18450,
    status: 'Success',
  },
  {
    id: 'bkp-100',
    timestamp: '2026-08-11T20:00:00Z',
    backupType: 'Automatic Periodic',
    contactsCount: 5,
    messagesCount: 2,
    tasksCount: 3,
    fileSizeBytes: 14200,
    status: 'Success',
  },
];
